module.exports = ".no-content {\n  height: 80vh;\n  text-align: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/no-content/no-content.component.scss
// module id = ./src/app/shared/no-content/no-content.component.scss
// module chunks = main